import { render, staticRenderFns } from "./DashboardPowerBI.vue?vue&type=template&id=0768789b&scoped=true"
import script from "./DashboardPowerBI.vue?vue&type=script&lang=js"
export * from "./DashboardPowerBI.vue?vue&type=script&lang=js"
import style0 from "./DashboardPowerBI.vue?vue&type=style&index=0&id=0768789b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0768789b",
  null
  
)

export default component.exports